export const CHECKOUT_FLOW = {
  WITH_MV_SUBSCRIPTION_ONLY: 'flowWithMobileVoiceSubscriptionOnly',
  DEVICE_WITH_SUBSCRIPTION: 'flowWithDeviceAndSubscription',
  WITH_OUT_SUBSCRIPTION: 'flowWithoutSubscription',
  WITH_MOBILE_BROADBAND_SUBSCRIPTION: 'flowWithMobileBroadBandSubscription',
  NO_FLOW: 'noFlow'
}
export const FLOW_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE'
}
export const SIM_CARD_TYPE = {
  E_SIM: 'ESIMFiveGSA',
  PHYSICAL_SIM: 'FiveGSA'
}

export const SECRET_NUMBER_TYPE = {
  SECRET_ADDRESS: 'SecretAddress',
  SECRET_ALL: 'SecretAll',
  SECRET_NONE: 'SecretNone',
  SECRET_NUMBER: 'SecretNumber'
}
export const INITIATE_NP = {
  ASAP: true,
  WHEN_BINDING_EXPIRES: false
}
export const CUSTOMER_TYPE = {
  BUSINESS: 'business',
  PRIVATE: 'private'
}

export const CUSTOMER_SUBSCRIPTION_TYPE = {
  NEW_NUMBER: 'new-number',
  MOVE_NUMBER: 'move-number',
  CHANGE_SUBSCRIPTION: 'change-subscription',
  CHANGE_SUBSCRIPTION_ON_MIT_TELMORE: 'change-subscription-on-mit-telmore',
  KEEP_SUBSCRIPTION: 'keep-subscription'
}
export const PAYMENT_OPTIONS = {
  MOBILE_PAY: 'MOBILE_PAY',
  CREDIT_CARD: 'CREDIT_CARD',
  ACCOUNT_PAYMENT: 'ACCOUNT_PAYMENT'
}

export const CART_ITEM_GROUP_PURCHASE_TYPE = {
  HARDWARE_CASH_WITH_SUBSCRIPTION: 'HARDWARE_CASH_WITH_SUBSCRIPTION',
  HARDWARE_CASH_WITH_NEW_SUBSCRIPTION: 'HARDWARE_CASH_WITH_NEW_SUBSCRIPTION',
  HARDWARE_CASH_WITH_NP_SUBSCRIPTION: 'HARDWARE_CASH_WITH_NP_SUBSCRIPTION',
  HARDWARE_CASH_WITH_CHANGE_SUBSCRIPTION: 'HARDWARE_CASH_WITH_CHANGE_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_WITH_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_WITH_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_WITH_NEW_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_WITH_NEW_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_WITH_NP_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_WITH_NP_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_WITH_CHANGE_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_WITH_CHANGE_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_CASH_WITHOUT_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_CASH_WITHOUT_SUBSCRIPTION',
  HARDWARE_CASH_WITHOUT_SUBSCRIPTION: 'HARDWARE_CASH_WITHOUT_SUBSCRIPTION',
  HARDWARE_INSTALLMENT_WITH_KEEPING_SUBSCRIPTION: 'HARDWARE_INSTALLMENT_WITH_KEEPING_SUBSCRIPTION',
  HARDWARE_CASH_WITH_KEEPING_SUBSCRIPTION: 'HARDWARE_CASH_WITH_KEEPING_SUBSCRIPTION',
  SUBSCRIPTION_ONLY: 'SUBSCRIPTION_ONLY',
  CANT_BE_DETERMINED_YET: 'CANT_BE_DETERMINED_YET',
  UNKNOWN: 'UNKNOWN'
}
